import { defineComponent as _defineComponent } from 'vue'
import { reactive } from 'vue';
import { instance as api } from '@/helpers/api';
import { commitToast } from '@/plugins/toast';
import { errToStr, formRules } from '@/helpers/tools';
import { LocationCollection } from '@/models/Location';
import IconBtn from '../IconBtn.vue';
import { getI18nInstance as i18n } from '@/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccessibilityUrlField',
  props: {
    locationId: {
        type: Number,
        default: null,
    },
    accessibilityUrl: {
        type: String,
        default: null,
    },
    hideReloadBtn: {
        type: Boolean,
        default: false,
    },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;



const state = reactive({
    entriesBySearch: {
        edges: [
            {
                node: {
                    entryId: '',
                    name: '',
                    position: {
                        city: '',
                        postcode: '',
                        housenumber: '',
                        street: '',
                        lat: null,
                        lng: null,
                    },
                    publication: {
                        linkUrl: '',
                    },
                },
            },
        ],
    },
    loading: false,
    loaded: false,
    failed: false,
    dialog: false,
});



async function onLoadAccessibilityData() {
    resetStates();

    if (!props.locationId) {
        commitToast({ message: `${i18n().t('no_location_to_look_for')}`, color: 'error' });
        return;
    }

    state.loading = true;
    try {
        const location = await loadLocationForId(props.locationId);
        if (location) {
            await apiCall(location.get('address_id'));
        }
    } catch (error) {
        commitToast({ message: errToStr(error), color: 'error' });
    }
    state.loading = false;
}

async function loadLocationForId(id: number) {
    if (!id) {
        return null;
    }
    const collection = new LocationCollection();
    await collection.query({ id, showAllLocations: true });
    return collection.first();
}

/*
Example response:
{
    "data": {
        "entriesBySearch": {
            "edges": [
                {
                    "node": {
                        "entryId": "a uuid",
                        "name": "Seemuseum Kreuzlingen",
                        "publication": {
                            "iconUrl": "https:\/\/www.ginto.guide\/entries\/2f038f5e-ea9d-40e1-bffc-09291f8599d5\/sticker.svg",
                            "linkUrl": "https:\/\/www.ginto.guide\/entries\/2f038f5e-ea9d-40e1-bffc-09291f8599d5?lnk_src=business",
                            "iconText": "OK:GO - Klicken Sie hier f\u00fcr Informationen zur Zug\u00e4nglichkeit",
                            "linkText": "Detaillierte Zug\u00e4nglichkeitsinfos"
                        },
                        "position": {
                            "city": "Kreuzlingen",
                            "countryCode": "CH",
                            "housenumber": "3",
                            "lat": 47.6487596834061,
                            "lng": 9.18933329931871,
                            "postcode": "8280",
                            "street": "Seeweg "
                        }
                    }
                }
            ]
        }
    },
    "success": true
}
*/
async function apiCall(addressId: number) {
    const res = await api().get('/Address/getAccessibilityData', {
        params: {
            addressId: addressId,
        },
    });

    state.entriesBySearch = res?.data?.data.entriesBySearch;
    const edges = state.entriesBySearch.edges ?? [];

    if (edges.length < 1) {
        state.failed = true;
        commitToast({ message: `${i18n().t('no_location_found')}`, color: 'error' });
    } else if (edges.length === 1) {
        emit('input', edges[0].node.publication.linkUrl);
        state.loaded = true;
    } else {
        state.loaded = true;
        state.dialog = true;
    }
}

function resetStates() {
    state.loaded = state.failed = state.dialog = false;
}

return { __sfc: true,props, state, emit, onLoadAccessibilityData, loadLocationForId, apiCall, resetStates, formRules, IconBtn }
}

})